const methodList = {
  getThisBanner: (banner) => document.querySelector(`#${banner.location}`),
  // Permet d'afficher le texte
  textFormatter: (banner, text) => {
    return text
      .replace(/%m_poka_60mois%/, () =>
        !!banner.mPOKA60Month ? banner.mPOKA60Month : ""
      )
      .replace(/%dynamic(\d)%/gi, (match, p1) =>
        !!banner["dynamic" + p1] ? banner["dynamic" + p1] : ""
      )
      .replace(/\s(\.|,|\.{3}|\)|")/gm, "$1 ")
      .replace(/(\(|\[|\")\s/gm, "$1")
      .replace(/\s(\:|\;|\!|\?|\%|\+)/gm, "&nbsp;$1 ")
      .replace(/(\:)\s/gm, "$1&nbsp;");
  },
  trackLaunchCTA: (banner, cta = "") => {
    if (!!window.hasOwnProperty("_satellite")) {
      const getHtmlLabel = (labelEntry) => {
        const htmlElem = document.createElement("div");
        htmlElem.innerHTML = labelEntry;
        return htmlElem.innerText.trim();
      };
      (window as any)._satellite.track("DCRMBannerCTA", {
        label:
          !!banner.clickableBanner && !banner[cta + "Text"]
            ? "Zone clickable"
            : getHtmlLabel(banner[cta + "Text"]),
        placement: banner.location,
        campaign: banner.messageId,
      });
    }
  },
  setURLParameters: (url, form) => {
    // On extrait les paramètres et on les met dans un tableau
    const paramsFromURL = url?.match(/(\w+[^&]=\w+)/g) || [];
    // On efface tous les inputs préalables
    form.querySelectorAll("[type=hidden]").forEach((input) => input.remove());

    paramsFromURL.forEach((entry) => {
      const newHiddenInput = document.createElement("input");
      Object.assign(newHiddenInput, {
        type: "hidden",
        name: entry.split("=")[0],
        value: entry.split("=")[1],
      });
      form.append(newHiddenInput);
    });
  },

  onCtaClick: (banner) => {
    event.stopImmediatePropagation();

    // Définition du Formulaire et du bouton
    const cta = (event.target as any)?.matches(".btn-second") ? "cta2" : "cta1";
    const form =
      (event.target as any)
        ?.closest(".banner")
        ?.querySelector(".dcrmCTAForm") ||
      (document.querySelector(`#${banner.location} .dcrmCTAForm`) as any);

    if (
      banner[`${cta}URL`] === "https://cookieconsent" ||
      banner[`${cta}Webcallback`] ||
      !cta
    ) {
      if (banner[`${cta}URL`] === "https://cookieconsent") {
        (document.querySelector("a.cookiesdisplayparameters") as any).click();
      }
      return;
    }
    if (banner[`${cta}Webcallback`]) {
      return;
    }

    // Si message refused
    if (/refused$/.test(banner[`${cta}Reponse`])) {
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        methodList.getEmptyBanner(banner);
      });
      banner.celebrusHelper.refused();
    }

    // L'url est correcte
    if (!!banner[`${cta}URL`]) {
      // On insère les paramètres d'URL ici
      methodList.setURLParameters(banner[`${cta}URL`], form);

      // Gestion des réponses
      if (!!banner[cta + "Reponse"]) {
        if (/accepted$/i.test(banner[cta + "Reponse"])) {
          banner.celebrusHelper.accepted();
        } else {
          banner.celebrusHelper.custom(banner[cta + "Reponse"]);
        }
      } else {
        banner.celebrusHelper.accepted();
      }

      // On ajoute les paramètres de requette dans les attributs du formulaire
      Object.assign(form, {
        target:
          { true: "_blank", false: "_self" }?.[banner?.[`${cta}Target`]] ||
          "_self",
        action: banner[`${cta}URL`],
        method: "get",
      });

      form.submit();
    } else {
      return;
    }
  },
  onCloseClick: (banner) => {
    if (!!banner.crossAnswer) {
      banner.celebrusHelper.custom(banner.crossAnswer);
    } else {
      banner.celebrusHelper.refused();
    }
    methodList.getEmptyBanner(banner);
  },
  getEmptyBanner: (banner) => {
    window.dispatchEvent(
      new CustomEvent(`rtim-banner:${banner.location}`, {
        detail: {
          content: {
            emplacement: banner.location,
            nom_gabarit: "Gab20",
          },
          placement: {
            id: banner.location,
            size: "1260x630",
            zone: "udc-top",
          },
        },
      })
    );
  },
  setBackgroundStyle: (banner) => {
    let style = "";
    const bgImg = !!banner.imgBackground ? banner.imgBackground : "";
    const setPosition = (imageSrc) => {
      let output = "";
      const posList = imageSrc.match(
        /(top|bottom|left|right|center)|\d+%|\d+px/gim
      );
      if (!!posList) {
        posList.forEach((position, index) => {
          output += position + (index < posList.length - 1 ? " " : "");
        });
        return output;
      }
    };
    const setBG = (imageSrc) => {
      const format = imageSrc.match(/jpg|jpeg|png|gif|webp|svg/i)
        ? imageSrc.match(/jpg|jpeg|png|gif|webp|svg/i)[0]
        : "jpg";
      const filename = imageSrc.replace(
        /((no\-|)repeat)|(top|bottom|left|right|center)|(\d+%)|(\d+px)|jpg|jpeg|png|gif|webp|svg|\s+/gim,
        ""
      );
      return `url(${
        banner.celebrusAssetsPathFinder + filename
      }_333x333.${format})`;
    };

    if (!!bgImg) {
      // Background image
      style += !/^[0-9a-f]{3}$|^[0-9a-f]{6}$/.test(bgImg)
        ? `background-image: ${setBG(bgImg)}; `
        : "";
      // Background-color
      style += /^[0-9a-f]{3}$|^[0-9a-f]{6}$/.test(bgImg)
        ? `background-color: #${bgImg}; `
        : "";
      // Background-repeat
      style += !!/((no\-|)repeat)/.test(bgImg)
        ? `background-repeat: ${bgImg.match(/((no\-|)repeat)/)[0]}; `
        : "";
      // Background-postion
      style += !!setPosition(bgImg)
        ? `background-position: ${setPosition(bgImg)}; `
        : "";
    }
    return style;
  },
  getIconClass: (icon) => "icon-hb-next-" + icon,
};

export default methodList;
